import { Grid2 } from "@mui/material";
import React from "react";
import LeftSection from "./sections/LeftSection";
import RightSection from "./sections/RightSection";

export default function TherapistRegistrationPage() {
  return (
    <Grid2
      container
      // spacing={2}
      height={"100vh"}
      // direction="row"
      sx={{ bgcolor: "#fafafa" }}
    >
      {/* Left Section */}
      <LeftSection />
      {/* Right Section */}
      <RightSection />
    </Grid2>
  );
}
